import { Component, type ErrorInfo, type ReactNode } from "react";
import { Icon } from "../icons/Icon";
import { reportError } from "../lib/errors";

type Props = { children: ReactNode /** 変わると表示を戻す（ページの移動） */; resetKey?: string };
type State = { error: unknown };

/** 画面の枠に置くエラーの境界。1 画面が壊れても、ヘッダーと他の画面は使える */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: unknown): State {
    return { error };
  }

  componentDidCatch(error: unknown, info: ErrorInfo) {
    reportError(error, { componentStack: info.componentStack });
  }

  componentDidUpdate(prev: Props) {
    if (this.state.error && prev.resetKey !== this.props.resetKey) this.setState({ error: null });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <main className="page">
        <div className="empty error" role="alert" data-testid="page-error">
          <Icon name="warning" size={28} />
          <p>画面を表示できませんでした。書きかけのレイアウトは端末に残っています。画面を読み込み直してください。</p>
          <button type="button" className="btn" onClick={() => window.location.reload()}>
            <Icon name="sync" />
            読み込み直す
          </button>
        </div>
      </main>
    );
  }
}
